module.exports = __webpack_public_path__ + "img/huailai02.68492ab7.png";